module.exports = __webpack_public_path__ + "static/img/HAMPTON-MDF.94afbcc.png";


//////////////////
// WEBPACK FOOTER
// ./static/materials/cortina/HAMPTON-MDF.png
// module id = 57Fn
// module chunks = 0